import { useEffect, useState } from "react";

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const links = [
    { id: "work", label: "UI/UX" },
    { id: "illustrations", label: "Illustration" },
    { id: "graphic", label: "Graphic" },
    { id: "about", label: "About" },
    { id: "contact", label: "Contact" },
  ];

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const go = (id) => {
    setOpen(false);
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  // Over Hero (top, black panel) → white text. After scroll → ink.
  const linkColor = scrolled ? "text-[var(--ink)]" : "text-white";

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        scrolled ? "backdrop-blur-xl bg-white/70 border-b border-white/40" : "bg-transparent"
      }`}
      data-testid="site-navbar"
    >
      <div className="max-w-[1600px] mx-auto px-6 md:px-12 lg:px-20 py-5 flex items-center justify-between">
        <button
          onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
          className="flex items-center gap-3"
          data-testid="nav-logo"
        >
          <img
            src="/brand/emily-logo.png"
            alt="Emilly"
            className="h-10 md:h-12 w-auto select-none"
            draggable={false}
          />
          <span
            className={`font-mono text-[10px] uppercase tracking-[0.25em] ${
              scrolled ? "text-[var(--ink-soft)]" : "text-white/60"
            }`}
          >
            ©26
          </span>
        </button>

        <nav className="hidden md:flex items-center gap-10">
          {links.map((l) => (
            <button
              key={l.id}
              onClick={() => go(l.id)}
              data-testid={`nav-link-${l.id}`}
              className={`font-mono text-[11px] uppercase tracking-[0.25em] link-underline transition-colors duration-300 ${linkColor}`}
            >
              {l.label}
            </button>
          ))}
        </nav>

        <div className="hidden md:flex items-center gap-4" />

        <button
          className={`md:hidden font-mono text-xs uppercase tracking-widest transition-colors duration-300 ${linkColor}`}
          onClick={() => setOpen((v) => !v)}
          data-testid="nav-mobile-toggle"
        >
          {open ? "Close" : "Menu"}
        </button>
      </div>

      {open && (
        <div className="md:hidden bg-white border-t border-[var(--line)]">
          <div className="px-6 py-8 flex flex-col gap-6">
            {links.map((l) => (
              <button
                key={l.id}
                onClick={() => go(l.id)}
                data-testid={`mobile-nav-link-${l.id}`}
                className="text-left font-sans-display uppercase text-3xl text-[var(--ink)]"
              >
                {l.label}
              </button>
            ))}
          </div>
        </div>
      )}
    </header>
  );
}
